import { useMemo } from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useReportContext } from "../../components/Report/ReportContext/useReportContext";

/**
 * Resuelve los catálogos que declara `options` en el registro de dominios.
 * Vive aparte para que searchDomains.js siga siendo declarativo y sin hooks.
 */
export const useFilterOptions = () => {
  const [t] = useTranslation("report");
  const { statusOptions, kindOfEntryways, severityOptions, indicatorOptions } =
    useReportContext();

  return useMemo(() => {
    const currentYear = dayjs().year();
    const years = Array.from(
      { length: currentYear - 2015 + 1 },
      (_, index) => {
        const year = currentYear - index;
        return { value: year.toString(), label: year.toString() };
      }
    );

    return {
      years,
      reportStatus: statusOptions,
      // indicatorOptions trae la llave con prefijo (indicator_has_plan); en la
      // URL se guarda sin el, y buildRequestPayload lo vuelve a poner.
      indicators: indicatorOptions.map((option) => ({
        value: option.key.replace("indicator_", ""),
        label: option.label,
        iconName: option.iconName,
        color: option.color,
      })),
      entryways: kindOfEntryways,
      severity: severityOptions,
      investigationStatus: [
        { value: "NEW", label: t("investigationStatus.new") },
        { value: "PENDING", label: t("investigationStatus.pending") },
        { value: "PROCESS", label: t("investigationStatus.process") },
        { value: "COMPLETE", label: t("investigationStatus.complete") },
      ],
      investigationKind: [
        { value: "false", label: t("searchBar.investigation_simple") },
        { value: "true", label: t("searchBar.investigation_advance") },
      ],
    };
  }, [statusOptions, kindOfEntryways, severityOptions, indicatorOptions, t]);
};
